import React from 'react'
import Listing from './Listing'
import { SectionTitle } from 'scripts/helpers/AppHelper'

const List = (props) => {
  let {data, theme, slug, id, title, titleArrow} = props
  if (!data) { return null }
  const titleProps = {title: title, slug: slug, id: id, type: 'page', arrow: titleArrow}
  return (
    <div className={`component-listing ${theme || ''}`}>
      <SectionTitle {...titleProps} />
      <Listing {...props} />
    </div>
  )
}

export default List



// WEBPACK FOOTER //
// ./assets/js/components/list/List.jsx